"use client"

import { Container } from "@mui/material"
import CssBaseline from "@mui/material/CssBaseline"
import { Experimental_CssVarsProvider as CssVarsProvider } from "@mui/material/styles"

import { PropsWithChildren } from "react"

import { ArweaveProvider } from "./ArweaveProvider"
import { Footer } from "./Footer"
import Header from "./Header"
import { theme } from "./theme"
import { PortfolioAgentOnboarding } from "../PortfolioAgentOnboarding"

export default function RootLayoutUI({ children }: PropsWithChildren) {
  return (
    <>
      <CssVarsProvider theme={theme} defaultMode="system" modeStorageKey="dexi-mode">
        <CssBaseline />
        <ArweaveProvider>
          <Header />
          <Container maxWidth="xl" sx={{ minHeight: "calc(100vh - 177px)", paddingY: 3 }}>
            {children}
          </Container>
          <Footer />
          <PortfolioAgentOnboarding />
        </ArweaveProvider>
      </CssVarsProvider>
    </>
  )
}
